export const API_KEY = '6216a8a0-4540-4fda-b938-481f523b7bd3';